import type { UserPrefs } from '../../types';
import selectRepresentativeLoadProfile from './selectRepresentativeLoadProfile';

import selectRate from '../rate/selectRate';

const genHomeLoadProfile = (userPrefs: UserPrefs) => {
  const rate = selectRate(userPrefs.currentElectricRate, userPrefs.zipcode);

  const representativeLoadProfile = selectRepresentativeLoadProfile(userPrefs);

  return representativeLoadProfile
    .scale({ debug: false })
    .toAverageMonthlyBill(userPrefs.homeElectricBillMonthlyAvg, rate);
};

export default genHomeLoadProfile;
